// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3oXNt","noInteraction":"EventWrapper_noInteraction__2g0EV","pointerPassthrough":"EventWrapper_pointerPassthrough__2ALZy"};